var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V6M18 9C17.2044 9 16.4413 9.31607 15.8787 9.87868C15.3161 10.4413 15 11.2044 15 12C15 12.7956 15.3161 13.5587 15.8787 14.1213C16.4413 14.6839 17.2044 15 18 15M18 9C18.7956 9 19.5587 9.31607 20.1213 9.87868C20.6839 10.4413 21 11.2044 21 12C21 12.7956 20.6839 13.5587 20.1213 14.1213C19.5587 14.6839 18.7956 15 18 15M18 15V30M9 27C9.79565 27 10.5587 26.6839 11.1213 26.1213C11.6839 25.5587 12 24.7956 12 24C12 23.2044 11.6839 22.4413 11.1213 21.8787C10.5587 21.3161 9.79565 21 9 21M9 27C8.20435 27 7.44129 26.6839 6.87868 26.1213C6.31607 25.5587 6 24.7956 6 24C6 23.2044 6.31607 22.4413 6.87868 21.8787C7.44129 21.3161 8.20435 21 9 21M9 27V30M9 21V6M27 27C27.7956 27 28.5587 26.6839 29.1213 26.1213C29.6839 25.5587 30 24.7956 30 24C30 23.2044 29.6839 22.4413 29.1213 21.8787C28.5587 21.3161 27.7956 21 27 21M27 27C26.2044 27 25.4413 26.6839 24.8787 26.1213C24.3161 25.5587 24 24.7956 24 24C24 23.2044 24.3161 22.4413 24.8787 21.8787C25.4413 21.3161 26.2044 21 27 21M27 27V30M27 21V6",
    stroke: "#0483F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bb15eec79acd87201c88ad9215439592.svg";
export { ForwardRef as ReactComponent };